import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { RecentWinners } from 'app/components/AppHeader/RecentWinners';
import { ProfileMenuContainer } from 'app/components/Sidebar/ProfileMenuContainer';
import { Route } from 'app/enums';
import { AppCountersContext } from 'app/providers';
import { AddFundsModal } from 'modules/payments/components/AddFundsModal';
import { UserBalance } from 'modules/payments/components/UserBalance';
import { WithdrawFundsModal } from 'modules/payments/components/WithdrawFundsModal';
import { WithdrawFundsModalConfirmed } from 'modules/payments/components/WithdrawFundsModal/WithdrawFundsConfirmedModal';
import React, { FC, useCallback, useContext, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ActionGuard } from 'shared/components/ActionGuard';
import { Logo } from 'shared/components/Logo';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useStyles } from './AppHeader.styles';
import { SwapModal } from 'modules/payments/components/SwapModal';
import { AutoSwapModal } from 'modules/payments/components/AutoSwapModal';

export const AppHeader: FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { keycloak } = useKeycloak();
  const theme = useTheme();

  const { onlinePlayersCount } = useContext(AppCountersContext);
  const isFullScreen = useMediaQuery(theme.breakpoints.up('lg'));

  const isHome = useMemo(() => pathname === Route.Home, [pathname]);
  const playersOnlineLabel = useMemo(() => {
    if (!keycloak?.authenticated) {
      return 'Players ONLINE';
    }

    return `${onlinePlayersCount} Players ONLINE`;
  }, [keycloak?.authenticated, onlinePlayersCount]);

  const goBackHandler = useCallback(() => navigate(-1), [navigate]);
  const openPlayersPageHandler = useCallback(() => navigate(Route.PlayersOnline), [navigate]);

  return (
    <>
      <header>
        <Box className={classes.root}>
          <Logo />

          <Box className={classes.container}>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Box display="flex" flexDirection="row">
                {isFullScreen && (
                  <>
                    <Box className={classes.navigationControls}>
                      {!isHome && (
                        <Box className={classes.backButton}>
                          <ArrowBackIcon onClick={goBackHandler} />
                        </Box>
                      )}
                      <ActionGuard>
                        <Typography
                          className={classes.playersOnline}
                          onClick={openPlayersPageHandler}
                        >
                          {playersOnlineLabel}
                        </Typography>
                      </ActionGuard>
                    </Box>
                    <Box maxWidth="200px" width="200px">
                      <RecentWinners />
                    </Box>
                  </>
                )}
              </Box>
              <UserBalance />
            </Box>
          </Box>

          <Box className={classes.profileMenuContainer}>
            <ProfileMenuContainer />
          </Box>
        </Box>
      </header>

      <AddFundsModal />
      <WithdrawFundsModal />
      <WithdrawFundsModalConfirmed />
      <SwapModal />
      <AutoSwapModal />
    </>
  );
};
